import { Component, effect, ElementRef, input, OnDestroy, output, viewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { Subscription } from 'rxjs'
import { observeIntersection$ } from '../../../util'

@Component({
  selector: 'lib-load-more-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './load-more-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './load-more-button.component.scss',
})
export class LoadMoreButtonComponent implements OnDestroy {
  readonly continuationToken = input<string>()
  readonly loading = input<boolean>(false)

  readonly loadMore = output<string>()

  /// Observe intersection of load more button
  readonly btnLoadMore = viewChild<ElementRef<HTMLButtonElement>>('btnLoadMore')
  private loadMoreSub?: Subscription
  private readonly createObserverEffect = effect(() => {
    const element = this.btnLoadMore()?.nativeElement
    if (element) {
      this.loadMoreSub?.unsubscribe()
      this.loadMoreSub = observeIntersection$(element).subscribe((entry) => {
        const token = this.continuationToken()
        if (entry.isIntersecting && token) {
          this.loadMore.emit(token)
        }
      })
    }
  })

  ngOnDestroy(): void {
    this.loadMoreSub?.unsubscribe()
  }
}
